
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1103Dialog extends Serenity.EntityDialog<Report_1103Row, any> {
        protected getFormKey() { return Report_1103Form.formKey; }
        protected getIdProperty() { return Report_1103Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1103Row.localTextPrefix; }
        protected getNameProperty() { return Report_1103Row.nameProperty; }
        protected getService() { return Report_1103Service.baseUrl; }
        protected getDeletePermission() { return Report_1103Row.deletePermission; }
        protected getInsertPermission() { return Report_1103Row.insertPermission; }
        protected getUpdatePermission() { return Report_1103Row.updatePermission; }

        protected form = new Report_1103Form(this.idPrefix);

    }
}